<template>
  <div class="w">
    <div class="datails_nav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.type == 4" :to="{ path: '/Assume' }">揭榜挂帅</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ path: '/AboutInform' }">通知·资讯</el-breadcrumb-item>

        <el-breadcrumb-item v-if="$route.query.type == 4">通知详情</el-breadcrumb-item>
        <el-breadcrumb-item v-else>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 标题 -->
    <div class="toptitle">
      <div class="titletext">{{ list.Titile }}</div>
      <div class="titlespan">
        <span>
          <img src="../../assets/Assume-Image/lishi.png" alt />
          <!-- {{ list.CreateTime.substring(0, 10) }} -->
          {{ list.CreateTime }}
        </span>
        <span class="titlespan2">
          <img src="../../assets/Assume-Image/jianbao.png" alt />
          {{ list.SourceWebsite }}
        </span>
        <span class="titlespan3">
          <img src="../../assets/Assume-Image/眼睛.png" alt />
          <span>{{ list.ReadingVolume }}</span>
        </span>
        <!-- <span>
                    <img src="../Images/faxian.png" alt="">
        10200</span>-->
      </div>
    </div>
    <div class="tent" v-html="list.Details"></div>
  </div>
</template>
<script>
import { getAction, postAction } from '@/api/api'
import qs from 'qs'
import { NewsList } from '@/api/url'
import $ from '../../../public/jquery-2.1.1.js'
export default {
  data() {
    return {
      list: {},
      Newid: '',
    }
  },
  created() {
  
    //首页产经资讯和 政策法规 判断 勿动
    this.Newid = this.$route.query.id
    if (this.$route.query.type == 1 || this.$route.query.type == 2) {
      this.LoadOthers(this.$route.query.type)
    } else {
      this.NewsIfo()
    }
  },
  mounted() {
    this.ToNewsInfo()
  },
  methods: {
     ToNewsInfo() {
      //判断是否是PC设备，true是，false不是
         //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j])>0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        this.$router.push({
          path: '/NewsInfo',
          query: { type: this.$route.query.type, id: this.Newid },
        })
      } else {
       window.location.href=this.Urls+'/Mobile/index.html#/AboutNotice?data=' + this.Newid + '&type='+ this.$route.query.type
      }
    },
    LoadOthers(n) {
      let vm = this;
      let data = {
        action: "Get_InformationTzggDetails",
        Type:n,
        ID: vm.Newid
      };

      postAction(NewsList, this.$qs.stringify(data)).then((res) => {
        console.log(res)
        vm.list = {
             Titile: res.Titile,
             SourceWebsite: res.SourceWebsite,
             CreateTime: res.CreateTime,
             ReadingVolume: 0,
             Details: res.Details,
          }
      });
      // let url1 ="";
      // if(n==1)
      // {
      //    url1 =   'http://122.112.231.161:13500/r4QwXEGi/api/industry/category/detail?id=' //"http://122.112.231.161:1333/r4QwXEGi/api/policy/category/detail?id=";
      // }
      // else
      // {
      //   url1 =  'http://122.112.231.161:13500/r4QwXEGi/api/policy/category/detail?id=';
      // }
      
      // let vm = this
      // $.ajax({
      //   type: 'get',
      //   url:
      //   url1 + vm.Newid,
      //   dataType: 'json',
      //   async: false,
      //   success: function (data) {
      //     vm.list = {
      //       Titile: data.data.name,
      //       Spare2: data.data.properties.来源网站,
      //       CreateTime: data.data.properties.发布时间,
      //       ReadingVolume: 0,
      //       Details: data.data.properties.内容,
      //     }
      //     //// console.log(vm.list);
      //   },
      // })
    },
    NewsIfo() {
      let data = {
        action: 'Get_InformationInfo',
        ID: this.Newid,
      }
      postAction(NewsList, this.$qs.stringify(data)).then((res) => {
        //// console.log("Get_InformationInfo", res);
        this.list = res
        this.list.SourceWebsite= res.Spare2
      })
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  margin: 0rem;
  font-family: Microsoft YaHei;
  left: 0rem;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  box-sizing: border-box;
  overflow: hidden;
}
.w {
  width: 80rem;
  margin: 3rem auto 5rem;
  overflow: hidden;
}

#header {
  height: 7.4375rem;
  border-bottom: 0.0625rem solid #ffffffa9;
  background-color: #222222;
  width: 100%;
}
.datails_nav {
  text-align: left;
  height: 5.125rem;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.datails_nav .layui-breadcrumb a {
  color: #222222 !important;
}
.datails_nav .layui-breadcrumb img {
  width: 0.875rem;
  height: 0.875rem;
  margin-right: 0.625rem;
}
/* 标题 */
.toptitlet {
  text-align: center;
}
.lang {
  margin: 0 0.625rem;
  color: #999;
}
.titletext {
  font-size: 2.2rem;
  font-weight: 800;
}
.titlespan {
  margin-top: 1.375rem;
  color: #999;
}
.titlespan span {
  display: inline-block;
}
.titlespan img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
  vertical-align: bottom;
}
.titlespan2 {
  margin: 0 2.5rem;
}
.titlespan3 {
  font-size: 1rem;
}
.titlespan3 img {
  height: 2rem;
  width: 2rem;
  vertical-align: middle;
}
.content {
  margin: 2.5rem 0;
  color: #666666;
  text-align: left;
  line-height: 2rem;
}
.content div {
  margin-top: 0.625rem;
}
/* 内容 */
.tent {
  margin-top: 4rem;
  font-size: 1rem !important;
  text-align: left;
  line-height: 1.8rem;
}
#lay_a {
  color: #308bec !important;
}
img {
  width: 100%;
  height: 100%;
}
</style>